import { UseQueryOptions, useInfiniteQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { Block, api, ReviewSortCriteriaValue, BlockV2 } from '@/apis';

import { useCoreQuery } from '../core';
import { keys } from '../keys';

export const useCampaignQuery = (
  pk: string,
  preview?: string,
  options?: UseQueryOptions<Block, AxiosError>,
) =>
  useCoreQuery(
    keys.campaign.campaign(pk),
    async () => api.campaign.getCampaign(pk, preview).then((res) => res.block),
    options,
  );

export const useCampaignV2Query = (pk: string, options?: UseQueryOptions<BlockV2, AxiosError>) =>
  useCoreQuery(
    keys.campaign.campaignV2(pk),
    async () => api.campaign.getCampaignV2(pk).then((res) => res),
    options,
  );

export const useCampaignReviewsQuery = (campaign_id: number, sort_by: ReviewSortCriteriaValue) => {
  return useInfiniteQuery(
    keys.campaign.campaignReviews(campaign_id, sort_by),
    async ({ pageParam = 1 }) => {
      const data = await api.campaign.getCampaignReviews(campaign_id, pageParam, sort_by);
      return data;
    },
    {
      getNextPageParam: (lastPage) => {
        if (lastPage.current_page === lastPage.total_page) {
          return undefined;
        }
        return lastPage.current_page + 1;
      },
    },
  );
};
